<template lang="pug">
  .xsell-products
    .products-wrap
      .md-fixed-width-tweak-upper.lg-fixed-width-tweak-upper
        XsellProduct(v-for="product in suggestedAddons" :key="product.id" :product="product")

    .continue-to-bag.text-center
      button.back.btn-reset.arrow-link.xs-f-small.lg-f-medium.max-at-tweak(v-if="proProduct.id" @click="$emit('show-tab', 'BundleAndSave')")
        span.icon-arrow-back.xs-f-xlarge.max-at-tweak
          span.ada-tooltip arrow back icon
        span.xs-f-small.lg-f-medium.max-at-tweak &nbsp;Back
      a.mr-btn.btn-inverse.btn-fixed-width.xs-f-xsmall.max-at-tweak(href="/cart" target="_self" data-mr-ass="color-pro-continue") continue to bag
  
</template>

<script>
  import { mapState, mapGetters } from "vuex";
  import vueProductSvc from '../../../services/vueProductSvc';
  import XsellProduct from "./XsellProduct";

  export default {
    name: "XsellProducts",

    components: { XsellProduct },

    computed: {
      ...mapState('cart', ['cart']),
      ...mapState('xsell', ['proProduct']),
      ...mapGetters('cart', [
        'suggestedAddons',
        'productIdInCart'
      ])
    },

    watch: {
      suggestedAddons(newVal) {
        if (newVal == 0) {
          window.location = '/cart';
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .xsell-products
    max-height 300em
    transition(max-height 600ms ease-in)
    overflow hidden
    padding-bottom 4em
    margin 0 auto

    .continue-to-bag
      padding 2em 5%
      background-color #f6f5f4

      .back
        padding 0.5em
        margin-right 1.5em

    @media mq-mobile
      .products-wrap
        text-align center

    @media mq-tablet
      .products-wrap
        width 39em
        padding-left 4%

    @media mq-tablet-tweak-upper
      .products-wrap
        width 37em
        padding-left 10%

        .xsell-product
          width 16.5em

    @media mq-desktop-md
      .products-wrap
        padding-left 15%

    @media mq-desktop-plus
      .products-wrap
        width 61em
        padding-left 12%

      .xsell-product
        width 17.5em

</style>